import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import * as z from 'zod'

export const TemplateFlexSuiteDetailsSchema = buildEntrySchemaFor('templateFlexSuiteDetails', {
  fields: z.lazy(() =>
    z.object({
      title: z.string().optional(),
    }),
  ),
})

export type TemplateFlexSuiteDetails = z.infer<typeof TemplateFlexSuiteDetailsSchema>
